import { WixComponentManifest } from '../../../schema';
import type { IMergerClass } from '../../componentManifestResolver.types';
import type { ElementsMergerConstructor } from './types';
import ComponentManifestMerger from '../ComponentManifest/ComponentManifest.merger';

function isEmptyObject(obj: object) {
  return Object.keys(obj).length === 0;
}

class ElementsMerger implements IMergerClass<WixComponentManifest['elements']> {
  private mainElements: Record<string, WixComponentManifest> = {};
  private referredElements: Record<string, WixComponentManifest> = {};

  constructor({ mainElements, referredElements }: ElementsMergerConstructor) {
    this.mainElements = mainElements || {};
    this.referredElements = referredElements || {};
  }

  public merge() {
    if (isEmptyObject(this.referredElements) && isEmptyObject(this.mainElements)) {
      return undefined;
    }

    const updatedElementsKeys = new Set([
      ...Object.keys(this.referredElements || {}),
      ...Object.keys(this.mainElements || {})
    ]);

    const updatedElements: WixComponentManifest['elements'] = {};

    updatedElementsKeys.forEach((elementKey) => {
      const mergedElement = new ComponentManifestMerger({
        manifest: this.mainElements[elementKey],
        referredManifest: this.referredElements[elementKey]
      }).merge();

      updatedElements[elementKey] = mergedElement;
    });

    return updatedElements;
  }
}

export default ElementsMerger;
